import script from "./ChimneysComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ChimneysComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__